import { Navigate } from "react-router-dom";
import { useAuth } from "../../auth/contexts/AuthProvider";
import { getUser } from "../../admin/infra/getUser";
import FunctionsProvider from "../contexts/FunctionsProvider";
import NotificationsProvider from "../contexts/NotificationsProvider";
import CalendarProvider from "../contexts/CalendarProvider";
import SmsProvider from "../../admin/context/SmsProvider";

type PrivateRouteProps = {
  children: React.ReactNode;
  roles?: string[];
  path?: string;
};

const PrivateRoute = ({ children, roles, path }: PrivateRouteProps) => {
  const { hasRole, userInfo } = useAuth();

  // Verificar se há dados básicos de autenticação no localStorage
  const hasAuthData = () => {
    const authKey = localStorage.getItem("authkey");
    const token = localStorage.getItem("rh-token");
    return !!(authKey && token);
  };

  // Se não há userInfo mas há dados de auth, aguardar carregamento
  if (!userInfo && hasAuthData()) {
    // Retorna um loader ou null para aguardar o carregamento do userInfo
    return null;
  }

  // Se não há userInfo e não há dados de auth, redirecionar para login
  if (!userInfo) {
    return <Navigate to="/login" replace />;
  }

  // Verificar permissões
  const jsonPermissions = getUser().permissions;
  const test = hasRole(path, jsonPermissions);

  if (!test) {
    return <Navigate to="/403" replace />;
  }

  // Usuário autenticado e com permissões
  return (
    <NotificationsProvider>
      <FunctionsProvider>
        <CalendarProvider>
          <SmsProvider>{children}</SmsProvider>
        </CalendarProvider>
      </FunctionsProvider>
    </NotificationsProvider>
  );
};

export default PrivateRoute;
